import { useEffect, useState } from 'react';
import { useIdentity } from '.';

import {
    canAccessCommonskuPaymentsDeepLink,
    isCommonskuPaymentsDeepLink,
} from '../components/admin-new/commonskuPaymentsDeepLink';

export default function useCommonskuPaymentsDeepLink() {
    const identity = useIdentity();
    const [shouldOpen, setShouldOpen] = useState(false);

    useEffect(() => {
        if (!isCommonskuPaymentsDeepLink()) {
            return;
        }
        if (!identity?.user_id) {
            return;
        }
        if (!canAccessCommonskuPaymentsDeepLink(identity)) {
            window.location.href = '/home.php';
            return;
        }
        setShouldOpen(true);
    }, [identity]);
    return { shouldOpen };
}
